export function formatearNumeroConComas(numero) {
	if (typeof numero !== 'number') {
		return 0;
	}

	const numeroFormateado = numero.toLocaleString('en-US', {
		maximumFractionDigits: 2,
	});
	return numeroFormateado;
}
